export default __webpack_public_path__ + "static/media/eye-pink.3e52e09f.svg";